import { render, staticRenderFns } from "./audio.vue?vue&type=template&id=d5b60c9c&scoped=true&"
import script from "./audio.vue?vue&type=script&lang=js&"
export * from "./audio.vue?vue&type=script&lang=js&"
import style0 from "./audio.vue?vue&type=style&index=0&id=d5b60c9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b60c9c",
  null
  
)

export default component.exports